import React, { useRef, useEffect, useCallback, useState} from 'react';
import SceneDetails from './SceneDetails.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK_TIME = 400;

const ScenesComponent = ({currentScene, scenes, sequencerEngine}) => { 
    let [sceneDragging, setSceneDragging] = useState(undefined);

    console.log('rendering scenes = ', scenes);
    const onDropScene = useCallback((scene) => {
        let fromIndex = scenes.indexOf(sceneDragging);
        let toIndex = scenes.indexOf(scene);
        sequencerEngine.scenes.moveScene(fromIndex, toIndex);
    }, [sceneDragging, scenes]);

    return (
        <div className="scenes-container">
          <div className="scenes-component">
            <div className="scenes-toolbar">
              <div className="scenes-header">
                Scenes
              </div>
              {!currentScene ?
               <div
                 onClick={() => sequencerEngine.scenes.newScene()}
                 className="new-scene-btn">
                 +
               </div> : ''}
            </div>
            {scenes.map(
                x =>
                    <Scene
                      key={x.id}
                      onDropScene={onDropScene}
                      setSceneDragging={setSceneDragging}
                      sceneDragging={sceneDragging}
                      isCurrent={currentScene === x}
                      scenes={sequencerEngine.scenes}
                      scene={x}/>)}
          </div>
          <SceneDetails sequencerEngine={sequencerEngine} currentScene={currentScene}/>
        </div>
    );
}

const Scene = ({scene, scenes, isCurrent, setSceneDragging, sceneDragging, onDropScene}) => {
    let ref = useRef(0);
    let [renaming, setRenaming] = useState(false);
    let [name, setName] = useState(scene.name);
    let className = "scene-option";
    if (isCurrent) {
        className += " current";
    }

    const onClick = useCallback(() => {
        let date = new Date().getTime();
        if (date - ref.current <= DOUBLE_CLICK_TIME) {
            setRenaming(true);
        }
        ref.current = date;
        scenes.switchToScene(scene);
    }, [setRenaming]);

    const onChange = useCallback((e) => {
        setName(e.target.value);
    }, [setName]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            setRenaming(false);
            scene.name = name;
        }
    }, [setRenaming, name, scene]);

    return (
        <div
          draggable={true}
          onDragStart={() => setSceneDragging(scene)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => onDropScene(scene)}
          onClick={onClick}
          className={className}>
          {renaming ?
           <input
             onChange={onChange}
             onKeyDown={onKeyDown}
             type="text"
             value={name}/> :
           name}
          <div className="scene-info">
            {scene.patterns.map(x => x + 1).join(" - ")}
          </div>
          <div onClick={
              (e) => {
                  e.stopPropagation();
                  scenes.deleteScene(scene);
              }} className={isCurrent ? "delete-btn" : "hide delete-btn"}>x</div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      scenes: state.sequencer.scenes,
      currentScene: state.sequencer.currentScene
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenesComponent);
